import PropTypes from 'prop-types';

const defaultProps = {
  menuItems: []
};

const propTypes = {
  menuItems: PropTypes.array
};

export default {
  defaultProps,
  propTypes
}